<template>
  <v-row>
    <v-col cols="12" xs="12" class="pa-0">
      <TableUser ref="table" :show-title="true"></TableUser>
    </v-col>
    <v-col cols="12" class="text-right">
      <v-btn @click="createItem()" color="primary">Neu erstellen</v-btn>
    </v-col>
  </v-row>
</template>

<script>
// import Vue from 'vue'
import TableUser from "../tables/TableUser";
import Vue from "vue";

export default {
  name: 'Benutzer',
  components: {TableUser},
  data() {
    return {}
  },
  methods: {
    createItem: function () {
      console.log('createItem')
      Vue.prototype.$apiUser.createUser({}, this.onItemCreated)
    },
    onItemCreated: function (newItem) {
      console.log('onItemCreated', newItem)
      this.$router.push('/Benutzer/' + newItem.guid)
    }
  },
  mounted() {
    //Vue.prototype.$api.checkCredentials(this)
  }
}
</script>

<style scoped>

</style>
